export default __webpack_public_path__ + "static/octagon-7ce52c797aad2a50441923384eb88456.png";